import { apiService } from '../../shared/services/apiService';
import { NutritionCustomerAnalyticsInfo } from '../interfaces/NutritionCustomerAnalyticsInfo';
import { NutritionCustomerSuccessInfo } from '../interfaces/NutritionCustomerSuccessInfo';
import { DateRangePresetFilterRequest } from '../../shared/interfaces/DateRangePresetFilterRequest';

export const nutritionHomeService = {
  async getCustomerSuccess(): Promise<NutritionCustomerSuccessInfo> {
    const resp = await apiService.get<NutritionCustomerSuccessInfo>(
      '/api/nutrition/home-page/customer-success',
    );

    return resp.data;
  },

  async getCustomerAnalytics(
    body: DateRangePresetFilterRequest,
  ): Promise<NutritionCustomerAnalyticsInfo> {
    const resp = await apiService.post<NutritionCustomerAnalyticsInfo>(
      `/api/nutrition/home-page/customer-analytics`,
      body,
    );

    return resp.data;
  },
};
